import { useHistory } from 'react-router-dom'
import { getFormValues } from 'redux-form'
import { Fade } from '../../components/common'
import { ReshipmentsNeedingAction } from '../../components/reshipment'
import OrdersOrgSearchForm from '../forms/OrdersOrgSearchForm'
import { NAV_LINKS } from '../../constants/NavConstants'
import {
  ORG_SEARCH_FORM_NAME,
  ORG_SEARCH_FIELD_ID,
  ORG_SEARCH_FIELD_AICODE,
} from '../../constants/OrdersConstants'
import { isEmpty } from '../../utils/common'

const mapStateToProps = state => {
  const orgSearchValues = getFormValues(ORG_SEARCH_FORM_NAME)(state)
  return {
    orgId: orgSearchValues?.[ORG_SEARCH_FIELD_ID],
    aiCode: orgSearchValues?.[ORG_SEARCH_FIELD_AICODE],
  }
}

const OrdersPage = props => {
  const history = useHistory()
  const { orgId, aiCode } = props

  useEffect(() => {
    if (!isEmpty(orgId) && !isEmpty(aiCode)) {
      // const path = NAV_LINKS.reshipment.replace(':orgId', orgId).replace(':aiCode', aiCode)
      history.push({ pathname: NAV_LINKS.reshipment, search: `?orgId=${orgId}&aiCode=${aiCode}` })
    }
  }, [orgId, aiCode])

  return (
    <Fade>
      <div className="container">
        <div className="row">
          <div className="col-xs-12">
            <h1>Reshipment Orders</h1>
          </div>
        </div>
        <div className="row">
          <div className="col-xs-6">
            <OrdersOrgSearchForm />
          </div>
        </div>
        <ReshipmentsNeedingAction />
      </div>
    </Fade>
  )
}

export default connect(mapStateToProps, {})(OrdersPage)
